import closeSearch from './search/close-search'
import showAllResults from './search/show-all-results'
import instantSearch from './search/instant-search'
import mobileFiltersAccordion from './search/mobile-filters-accordion'
import header from './header'

/**
 * Organisms initialization.
 */
function organisms () {
  closeSearch()
  header()
  showAllResults()
  instantSearch()
  mobileFiltersAccordion()
}

export default organisms
